import { useEffect, useState } from 'react';
import { TOPIC_KEY } from '../global-constants';

export const useLocalStorage = (localStorageKey) => {
	const [value, setValue] = useState({});

	function storageEventHandler() {
		const item = JSON.parse(localStorage.getItem(localStorageKey));
		setValue(item);
	}

	// We subscribe to  DDC.pubsub to listen for changes in localStorage
	useEffect(() => {
		const subscriber = window.DDC.pubsub.subscribe(
			TOPIC_KEY,
			storageEventHandler
		);

		return () => {
			subscriber.unsubscribe();
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [localStorageKey]);

	return value;
};
